<div class="pt-2">
    <div [attr.id]="'questionPyramidResult' + chartId"></div>
</div>
